import ACCOUNTS_MARKETPLACE_API from 'api/accounts-marketplace/v1'
import { FETCH_PRODUCT, SET_DATA, SET_LOADING } from 'modules/AccountsMarketplace/Product/types'
import { call, put, takeLatest } from 'redux-saga/effects'

function* onLoadData({ payload: { id } }) {
  try {
    yield put({ type: SET_LOADING, payload: { loading: true } })

    const { response, error } = yield call(
      ACCOUNTS_MARKETPLACE_API.fetchProductById,
      { id },
    )

    if (error) {
      throw error
    }

    yield put({
      type: SET_DATA,
      payload: response.data,
    })
  } catch (error) {
    console.logXHR(error)
  } finally {
    yield put({ type: SET_LOADING, payload: { loading: false } })
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_PRODUCT, onLoadData)
}
